import { getCategoryColor } from '../lib/colors'

interface TagBadgeProps {
  name: string
  color: string
  /** Optional emoji icon. When present, renders in place of the colour
   * dot — the colour still informs the badge background tint so tags
   * remain scannable at a glance. Added 2026-04-25 (ADR 0027). */
  icon?: string
  /** When true, shows a subtle "shared with team" marker (small users
   * glyph) after the name. Added 2026-04-26 (ADR 0028). */
  shared?: boolean
  onRemove?: () => void
}

export default function TagBadge({ name, color, icon, shared, onRemove }: TagBadgeProps) {
  const hasIcon = !!icon
  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-zinc-100 px-1.5 py-0.5 text-[10px] text-zinc-600">
      {hasIcon ? (
        <span className="inline-block text-[11px] leading-none" aria-hidden="true">{icon}</span>
      ) : (
        <span className="h-1.5 w-1.5 shrink-0 rounded-full" style={{ backgroundColor: getCategoryColor(color) }} />
      )}
      <span className="max-w-[80px] truncate">{name}</span>
      {shared && (
        <svg
          width="9"
          height="9"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="shrink-0 text-zinc-400"
          aria-label="Shared with team"
        >
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      )}
      {onRemove && (
        <button onClick={(e) => { e.stopPropagation(); onRemove() }} className="ml-0.5 text-zinc-400 hover:text-zinc-600">
          ×
        </button>
      )}
    </span>
  )
}
